import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import UserManagement from "./components/UserManagement";
import WalletManagement from "./components/WalletManagement";
import BotManagement from "./components/BotManagement";
import HouseManagement from "./components/HouseManagement";
import DepositsManagement from "./components/DepositsManagement";
import WithdrawalsManagement from "./components/WithdrawalsManagement";
import BonusManagement from "./components/BonusManagement";
import PromoManagement from "./components/PromoManagement";

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminToken, setAdminToken] = useState(
    localStorage.getItem("adminToken"),
  );

  useEffect(() => {
    if (adminToken) {
      setIsAdmin(true);
    }
  }, [adminToken]);

  const handleLogin = (token) => {
    setAdminToken(token);
    localStorage.setItem("adminToken", token);
    setIsAdmin(true);
  };

  const handleLogout = () => {
    setAdminToken(null);
    localStorage.removeItem("adminToken");
    setIsAdmin(false);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            !isAdmin ? (
              <AdminLogin onLogin={handleLogin} />
            ) : (
              <Navigate to="/dashboard" />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            isAdmin ? (
              <AdminDashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/users"
          element={isAdmin ? <UserManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/wallet"
          element={isAdmin ? <WalletManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/bots"
          element={isAdmin ? <BotManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/house"
          element={isAdmin ? <HouseManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/deposits"
          element={isAdmin ? <DepositsManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/withdrawals"
          element={isAdmin ? <WithdrawalsManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/bonus"
          element={isAdmin ? <BonusManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/promo"
          element={isAdmin ? <PromoManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={<Navigate to={isAdmin ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
